import { Easing, Tween } from "@tweenjs/tween.js";
import { AnimatedSprite, TextStyle, Texture, Text } from "pixi.js";
import { AssessmentNote, NewAssessmentVisualizer } from "score_performance";
import { VisualNoteGroup } from "score_render";
import { SfxPlayer } from "../audio/SfxPlayer";
import { pixiAppHelper } from "../ui/pixi_apps";

export class RaAssessmentVisualizer extends NewAssessmentVisualizer {	
	private _explosion:Texture[];
	private _rewardTextStyle = new TextStyle({ fontFamily: "arial",
		fontSize: 100, fill: 0x00FF00, stroke: 1.0, fontWeight: "bold",
		align: "left" });
	
	private _streak:number = 0;
	
	private _tweenWrappers:_TweenWrapper<Text>[] = [];
	
	private _animationWrappers:_AnimationWrapper[] = []; //for cleanup
	
	
	public static readonly GREEN:number = 0x00FF00;
	public static readonly RED:number = 0xFF0000;
	
	constructor(explosion:Texture[]){
		super();
		this._explosion = explosion;
		window.requestAnimationFrame(this._handleAnimationFrame);
	}
	
	public override markNoteCorrect(note:AssessmentNote):void {
		this._streak++;
		this.setNoteColor(note.vng, RaAssessmentVisualizer.GREEN);
		this.addExplosion(note.vng);
		if (this._streak === 10){
			SfxPlayer.playSound('clap1');
		}
		else if (this._streak % 10 === 0){
			SfxPlayer.playSound('clap2');
		}
		this.displayText();
		if (this.autoMarkTiedNotes){
			this.markTiedNotes(note, RaAssessmentVisualizer.GREEN);
		}
	}
	
	public override markNoteIncorrect(note:AssessmentNote):void {
		this.setNoteColor(note.vng, RaAssessmentVisualizer.RED);
		if (this.autoMarkTiedNotes){
			this.markTiedNotes(note, RaAssessmentVisualizer.RED);
		}
		this._streak = 0;
	}
	
	public override addExtraNote(qNoteTime:number):void {
		super.addExtraNote(qNoteTime);
		this._streak = 0;
	}
	
	/**removes extra red notes and sets red/green notes back to black*/
	public override clearAssessmentVisuals():void {
		for (let wrapper of this._animationWrappers){
			if (wrapper.sprite.parent != null){
				wrapper.sprite.stop();
				wrapper.sprite.parent.removeChild(wrapper.sprite);
				wrapper.completionHandler = null;
			}
		}
		
		this.assessor.scoreViewer.assessmentOverlay.removeChildren(0);
		
		this._streak = 0;
		this._animationWrappers = [];
	}
	
	public addExplosion(vng:VisualNoteGroup):void {
		let sprite = new AnimatedSprite(this._explosion);
		sprite.animationSpeed = 0.50;
		let notehead = vng.noteheadList[0];
		sprite.pivot.x = 25;
		sprite.pivot.y = 75;
		sprite.x = vng.scoreX + notehead.x;
		sprite.y = vng.scoreY + notehead.y;
		this.assessor.scoreViewer.assessmentOverlay.addChild(sprite);
		sprite.loop = false;
		sprite.play();
		let wrapper = new _AnimationWrapper();
		wrapper.sprite = sprite;
		wrapper.completionHandler = () => {
			this.assessor.scoreViewer.assessmentOverlay.removeChild(sprite);
			wrapper.completionHandler = null;
			wrapper.sprite.onFrameChange = null;
			wrapper.sprite.onComplete = null;
		}
		sprite.onComplete = wrapper.completionHandler;
		sprite.onFrameChange = this._onSpriteFrameChange;
		this._animationWrappers.push(wrapper);
	}
	
	public displayText():void {
		let overlay = this.assessor.scoreViewer.assessmentOverlay;
		let vScore = this.assessor.scoreViewer.vScore;
		this._rewardTextStyle.fontSize = pixiAppHelper.app.canvas.width / 25;
		let tf = new Text({
			text: `${this._streak} note streak!`,
			style: this._rewardTextStyle });
		tf.pivot.x = tf.width / 2;
		tf.pivot.y = tf.height / 2;
		tf.y = pixiAppHelper.app.canvas.height / 2 - vScore.y;
		tf.x = pixiAppHelper.app.canvas.width / 2;
		
		let wrapper = new _TweenWrapper(tf);
		wrapper.tween = new Tween(tf)
			.to( { y: tf.y - 50, scaleY: 3.0, scaleX: 3.0, alpha: 0.0 }, 500)
			.onComplete(() => { wrapper.finished = true; })
			.start();
		overlay.addChild(tf);
		this._tweenWrappers.push(wrapper);
		
	}
	
	private _handleAnimationFrame = ():void => {
		for (let i = this._tweenWrappers.length - 1; i >= 0; i--){
			let wrapper = this._tweenWrappers[i];
			wrapper.tween.update();
			if (wrapper.finished){
				wrapper.object.parent.removeChild(wrapper.object);
				this._tweenWrappers.splice(i, 1);
			}
		}
		
		window.requestAnimationFrame(this._handleAnimationFrame);
	}
	
	private _onSpriteFrameChange = (currentFrame:number):void => {
		pixiAppHelper.requestRender();
	}
	
	// public override set assessor(value:Assessor) {
	// 	value.scoreViewer.forceScrolling = true;
	// 	super.assessor = value;
	// }
}

class _AnimationWrapper {
	public sprite:AnimatedSprite;
	public completionHandler:() => void;
}

class _TweenWrapper<T> {
	public object:T;
	public tween:Tween<any>;
	public finished:boolean = false;
	
	constructor(object:T){
		this.object = object;
	}
}